import { setResizingColumn } from '../../../../state/internal/actions.tsx';
import { defineTransaction } from '../../../common/transactions/index.tsx';
import { CLEAR_RESIZING_COLUMN } from './action.tsx';

export default defineTransaction(CLEAR_RESIZING_COLUMN, () => setResizingColumn(undefined));
